<template>
    <div
        class="c2-accordion-item"
        :class="[
            {
                'active': visible,
                'item-disabled': isDisabled,
                'item-active': visible
            }
        ]">
        <button
            class="accordion-toggle-button"
            :class="buttonClasses"
            :disabled="isDisabled" 
            @click="toggle"
        >
            <slot name="button"></slot>
        </button>
        <transition
            name="accordion"
            @enter="enter"
            @after-enter="afterEnter"
            @after-leave="afterLeave"
            @before-enter="beforeEnter"
            @before-leave="beforeLeave"
        >
            <div
                class="accordion-content"
                :class="panelClasses"
                v-show="visible"
            >
                <slot name="content"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'C2AccordionItem',
        props: {
            allowOneOpenPanel: {
                type: Boolean,
                default: false
            },
            buttonClasses: {
                type: [Array, String]
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            isOpen: {
                type: Boolean,
                default: false
            },
            panelClasses: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                visible: this.isOpen
            };
        },
        watch: {
            isOpen() {
                this.visible = this.isOpen;
            }
        },
        methods: {
            afterEnter: function(el) {
                el.style.height = '';
            },
            beforeEnter: function(el) {
                el.style.height = '0px';
            },
            closeAccordion() {
                this.visible = false;
            },
            openAccordion() {
                this.visible = true;
            },
            enter: function(el) {
                el.style.height = el.scrollHeight + 'px';
            },
            afterLeave: function(el) {
                el.style.height = '';
            },
            beforeLeave: function(el) {
                el.style.height = el.scrollHeight + 'px';
            },
            toggle() {
                this.visible = !this.visible;
                this.$emit('toggle')
            }
        },
    }
</script>

<style lang="scss">
    .accordion-enter,
    .accordion-leave-to {
        opacity: 0;
    }

    .accordion-leave-to {
        height: 0 !important;
    }

    .accordion-enter-active,
    .accordion-leave-active {
        overflow: hidden;
        transition: height 0.3s ease-in-out, opacity .3s ease-in-out;
        will-change: height, opacity;
    }
</style>
